export const DatasetNames = Object.freeze({
  ORDERS_PER_DAY: 'ordersPerDay',
  AVERAGE_OPTIONS: 'averageOptions',
  UNIQUE_CLIENTS: 'uniqueClients',
  CLOSES_PER_DAY: 'closesPerDay',
  LEADS_PER_DAY: 'leadsPerDay'
});



// WEBPACK FOOTER //
// ./src/config/industryDatasetNames.js